<main class="main">
  <div class="content">

    <bug-list></bug-list>
    <div class="divider" role="separator" aria-label="Divider"></div>
    <div class="right-side">
    </div>
  </div>
</main>
